// 
// Sundae Lane Product Inventory Summary
// - 
// 
window.theme = window.theme || {};

theme.CartInventoryNotice = (function() {

  function CartInventoryNotice(container) {
    this.container = container;

    if(!container){
      return;
    }

    this.current = {
      variantId: null,
      variant: null
    }

    this.statuses = {
      "in_stock": {
        in_stock: true,
        estimated_arrival_date: false,
        preorder_quantity_available: false
      },
      "in_stock_and_production": {
        in_stock: true,
        estimated_arrival_date: true,
        preorder_quantity_available: true
      },
      "under_production": {
        in_stock: false,
        estimated_arrival_date: true,
        preorder_quantity_available: true
      },
      "out_of_stock": {
        in_stock: false,
        estimated_arrival_date: false,
        preorder_quantity_available: false
      },
      "out_of_stock": {
        in_stock: false,
        estimated_arrival_date: true,
        preorder_quantity_available: false
      }
    }

    this.sectionId = this.container.id;

    this.bindElements();
    this.bindEvents();

  }

  CartInventoryNotice.prototype = {

    parseThemeData: function(){
      const themeDataContainer = document.querySelector(`[data-section="${this.sectionId}"]`)
      if (!themeDataContainer){
        console.log('error: Unable to load settings for marquee section')
        return;
      }

      const themeData = JSON.parse(themeDataContainer.innerHTML);
      if (!themeData){
        console.log('Error: Unable to find theme data');
        return;
      }
      return themeData;
    },

    bindElements: function(){
      const self = this;
      
    },

    bindEvents: async function(){
      const self = this;
      
      self.onPageLoad();

      document.addEventListener('ajaxProduct:added', function(event) {
        self.onPageLoad();
      });

      document.addEventListener('cart:updated', function(event) {
        let cart = event.detail.cart;
        
        if (!cart){
          console.log('Error: invalid variant id');
        }
        else {
          self.onPageLoad();
          return;
        }

        self.handleCartUpdate(cart);

      });

      document.addEventListener('cart:quantity', function(event) {
        let cart = event.detail.cart;
        
        if (!cart){
          console.log('Error: invalid variant id');
        }
        else {
          self.onPageLoad();
          return;
        }

        self.handleCartUpdate(cart);

      });

      document.addEventListener('cart:error', function(event) {
        let cart = event.detail.cart;
        let body = JSON.parse(event.detail.body);

        if (cart.message.indexOf('are in your cart') > -1){
          if (!body.id){
            return;
          }
          self.updateForCapacity(body.id);
        }
        
      });
    },

    updateForCapacity: function(key){
      const self = this;

      let cartItemContainer = this.container.querySelector(`.cart__item[data-key="${key}"]`);
      if (!cartItemContainer){
        return;
      }

      let loadingQuantity = cartItemContainer.querySelector('.js-qty__wrapper')
      if (loadingQuantity){
        let minusButton = loadingQuantity.querySelector('.js-qty__adjust--minus');
        minusButton.click();
      }

      self.hideAllStatusContainers(cartItemContainer);
      let status = 'at_capcity';
      const activeStatusContainer = cartItemContainer.querySelector(`[data-status="${status}"]`);
      activeStatusContainer.classList.remove('hide');
      
      self.removeLoading();
    },

    handleCartUpdate: async function(cart){
      const self = this;

      self.cart = cart;
      self.cartData = await self.getFullCartDetails();
      self.setInventoryNotices();
      self.cart.items.forEach(function(item){
        self.updateInventorySummary(item);
      });

    },

    onPageLoad: async function(){
      const self = this;

      self.cart = await self.getCart();
      self.cartData = await self.getFullCartDetails();
      let cartContents = document.querySelector('[data-products]');
      if (cartContents.children.length <= 0){
        console.log('Error: Cart hasnt loaded yet');
        return;
      }
      self.setInventoryNotices();
      self.cart.items.forEach(function(item){
        self.updateInventorySummary(item);
      });
      
    },

    getCart: async function(){
      const self = this;

      return new Promise(function(resolve, reject) {

        fetch('/cart.js')
        .then(res => res.text())
        .then(html => {
          if (html){
            resolve(JSON.parse(html));
          } 
        })
        .catch(error => {
          console.log(error);
          resolve();
        })
      });
    },

    setCart: async function(cart){
      const self = this;

      self.cart = cart;
    },

    getFullCartDetails: function(){
      const self = this;
      return new Promise(function(resolve, reject) {

        let query = ''
        self.cart.items.forEach(function(item){
          query = query + 'id:' + item.product_id + ' OR '
        });

        fetch(`/search?view=data&q='${query}`)
        .then(res => res.text())
        .then(html => {
          if (html){
            resolve(JSON.parse(html));
          } 
        })
        .catch(error => {
          console.log(error);
          resolve();
        });

      });
    },

    updateInventorySummary: function(item){
      const self = this;

      let cartItemContainer = document.querySelector(`.cart__item[data-key="${item.key}"]`);
      if (!cartItemContainer){
        console.log('Error: couldnt find cart item');
        return;
      }

      self.hideAllStatusContainers(cartItemContainer);
      
      let status = self.getStatus(item);
      const activeStatusContainer = cartItemContainer.querySelector(`[data-status="${status}"]`);
      activeStatusContainer.classList.remove('hide');

      Object.keys(item.inventoryNotice.summary).forEach(function(key){
        let property = item.inventoryNotice.summary[key].property;
        if (property && property != 'false'){
          const valueContainer = activeStatusContainer.querySelector(`[data-item="${key}"] .inventory-summary__value`);

          if (!valueContainer){
            return;
          }
          valueContainer.innerHTML = property;
        }
      });
      
      self.removeLoading();
    },
    
    removeLoading: function(){
      const self = this;
      let loadingContainers = document.querySelectorAll('.cart-item-inventory-notice');
      if (!loadingContainers){
        console.log('Error: Unable to find loading container');
        return;
      }
      loadingContainers.forEach(function(item){
        item.classList.remove('loading');
      });
     
    },

    setInventoryNotices: function(cart){
      const self = this;

      self.cart.items.forEach(function(cartItem){
        let data = self.cartData.find(function(dataItem){
          if (dataItem.productId == cartItem.product_id){
            return dataItem;
          }
        });
        cartItem.inventoryNotice = data.variants.find(function(item){
          if (item.variantId == cartItem.id){
            return item.summary;
          }
        });
        Object.keys(cartItem.inventoryNotice.summary).forEach(function(key){
          let property = cartItem.inventoryNotice.summary[key];
          
          let itemStatus = false
          if (property != null && property != 'false' && property != '0 items available' && property != 'Made to order' && property != '0 Items' || property == 'Vorsen stocked item'){
            itemStatus = true
          }
          cartItem.inventoryNotice.summary[key] = { property: property, status: itemStatus };
  

        });

      });
    },

    getStatus: function(item){
      const self = this;
      
      let status = 'error';

      let itemMetafields = item.inventoryNotice.summary;
      let itemInventory = item.inventoryNotice.inventory;
      let itemQuantityInCart = item.quantity;

      // console.log(item);

      if (itemMetafields['in_stock'].status && itemInventory > 0 && itemMetafields['estimated_arrival_date'].status == false){
        status = 'in_stock'
      }

      if (itemMetafields['in_stock'].status && itemMetafields['estimated_arrival_date'].status){
        status = 'in_stock_and_production'
      }

      if (itemInventory < itemQuantityInCart){
        status = 'over_ordered'
        item.inventoryNotice.summary.in_stock.property = `Available Qty ${itemInventory} In Stock`
      }

      if (itemInventory <= 0 && itemMetafields['estimated_arrival_date'].status && itemMetafields['preorder_quantity_available'].status == true){
        status = 'under_production'
      }

      if (itemInventory <= 0 && itemMetafields['estimated_arrival_date'].status == false || itemInventory <= 0 && itemMetafields['estimated_arrival_date'].status && itemMetafields['preorder_quantity_available'].status == false){
        status = 'out_of_stock'
      }

      if (itemMetafields['item_product'].status == false && itemMetafields['in_stock'].status == false && itemMetafields['preorder_quantity_available'].status == false){
        status = 'made_to_order'
      }

      return status;
    },

    hideAllStatusContainers: function(container){
      const self = this;
 
      container.querySelectorAll('.inventory-summary-status').forEach(function(item){
        item.classList.add('hide');
      });
    }

  }

  return CartInventoryNotice;

})();

document.addEventListener('DOMContentLoaded', function() {
  const cartInventoryNoticeContainers = document.querySelectorAll('.cart--inventory-notice');
  if (!window.theme.cartInventoryNotices && cartInventoryNoticeContainers){
    window.theme.cartInventoryNotices = [];
    cartInventoryNoticeContainers.forEach(function(container){
      window.theme.cartInventoryNotices.push(new theme.CartInventoryNotice(container));
    });
  }
});
